import React from 'react';
import PropTypes from 'prop-types';
// import { connect } from "react-redux";
import './LeftBar.css';

// Left Panel
function LeftBar({ height, style, open = true, children }) {
  return (
    <div id={`left-drawer`} className={`drawer ${open ? `open` : `close`}`} style={{ height, ...style }} >
      { React.Children.map(children, child => (React.isValidElement(child)) && React.cloneElement(child)) }
    </div>
  )
}

LeftBar.propTypes = {
  height: PropTypes.number.isRequired,
  open: PropTypes.bool,
  style: PropTypes.object
}

// const LeftBar = connect(
//   state => ({
//     open: (state.dimension && state.dimension.fullHeight) ? true : false
//   })
// )(ConnectedLeftBar);

export default LeftBar;
